import { Asset } from '@cube3/common/model/schema/resources/asset';
import { Upload } from '@cube3/common/model/schema/resources/file-upload';

import { uploadStateMessages } from '@cube3/cubicle/src/core/atoms/ProgressWithText/helpers';
import { MediaQueueTileStatus } from '@cube3/ui/src/Prefabs/MediaQueue/MediaQueueTile';
import { useMemo } from 'react';
import { parseUploadState } from '../../ContentPane/ContentTree/items/parseUploadState';

interface UploadStatus {
  status: MediaQueueTileStatus;
  label: string;
  progress?: number;
}

const statusLookup: { [key: string]: MediaQueueTileStatus } = {
  AssetUploadStatusPending: 'pending',
  AssetUploadStatusUplodadInitFailed: 'failed',
  AssetProcessingStatusUploading: 'active',
  AssetUploadStatusPaused: 'failed',
  AssetUploadStatusFailed: 'failed',
  AssetUploadStatusUplodadMissing: 'failed',
  AssetProcessingStatusPending: 'pending',
  AssetProcessingStatusProcessing: 'active',
  AssetProcessingStatusFailed: 'failed',
  AssetProcessingStatusComplete: 'success'
};

const statusProgress = {
  AssetUploadStatusPending: 0,
  AssetProcessingStatusPending: 100,
  AssetProcessingStatusUploading: true,
  AssetUploadStatusPaused: true,
  AssetUploadStatusFailed: true
};

const labels = {
  ...uploadStateMessages,
  AssetProcessingStatusComplete: 'Processing finished'
};

/**
 *
 * @param upload file-upload resource
 * @param asset matching asset
 * @returns Upload status object containing status type, label and progress value
 */
export const useUploadStatus = (
  upload: Upload = undefined,
  asset: Asset = undefined
): UploadStatus => {
  return useMemo(() => {
    const state = parseUploadState(asset?.processing_status, upload);

    const status = statusLookup[state];
    const label = labels[state];
    const progress = !statusProgress[state]
      ? undefined
      : statusProgress[state] === true
      ? upload.progress
      : statusProgress[state];

    return {
      status,
      label,
      // label: state,
      progress
    };
  }, [upload, asset]);
};
